import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ToLocaleDateBaseValueConverter {
    toView(value) {
        if (ObjectHelper.IsNotNullAndUndefined(value)) {
            return moment(value).format('l').replaceAll(" ", "");
        }
        return value;
    }
}